import { styled } from '@mui/material/styles';

export const StyledParagraph = styled('p')(({ theme }) => ({
  fontSize: '0.8em',
  color: theme.palette.error.main,
}));
